import { LOCATION_CHANGE } from '../reducers/routerReducer';

function createPrevUrlMiddleware () {
  return ({ dispatch, getState }) => next => action => {
    if (action.type !== LOCATION_CHANGE) {
      return next(action);
    }

    const location = getState().getIn(['routing', 'location']);
    const pathname = location ? location.get('pathname') : null;
    const search = location ? location.get('search') : null;

    const nextAction = Object.assign({}, action, {
      previous: {
        pathname,
        search
      }
    });

    return next(nextAction);
  };
}

const prevUrlMiddleware = createPrevUrlMiddleware();

export default prevUrlMiddleware;



// WEBPACK FOOTER //
// ./src/utils/middlewares/prevUrlMiddlewares.js